import React, { Component } from "react";
import PropTypes from "prop-types";
import Option from "./Option";
import MultiOptionElement from "./MultiOptionElement";
import MultiOptions from "./MultiOptions";
import { CheckBoxChecked, CheckBoxUnchecked } from "../../icons";
import MultiSelectSubmit from "./MultiSelectSubmit";
import MultiselectStepContainer from "./MultiselectStepContainer";
import MultiSelectButtonContainer from "./MultiSelectButtonContainer";


class MultiselectStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsCopy: [],
    };
  }

  componentDidMount() {
    this.setState({
      optionsCopy: this.props.step["choices"],
    });
  }

  defaultOptionStyle = {
    bgColor: "#ffffff",
    borderColor: "#3f51b5",
    color: "#3f51b5",
  };

  onOptionClick = ({ value }) => {
    const optionsArr = this.state.optionsCopy;

    optionsArr.forEach((obj) => {
      if (obj.value === value && obj.selected) {
        obj.selected = false;
      } else if(obj.value === value && !obj.selected) {
        obj.selected = true;
      }
      return obj;
    });
    this.setState({ optionsCopy: optionsArr });
  };

  onSubmit = () => {
    const { triggerNextStep } = this.props;
    const options = this.state.optionsCopy
      .filter((item) => item.selected)
      .map((obj) => obj.value);
    triggerNextStep(options.join('::'));
  };

  shuffle = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  checkAndRandomiseOption = (option) => {
    const shouldShuffle = option?.some((obj) =>
      obj.hasOwnProperty("randomise")
    );

    if (!shouldShuffle) {
      return option;
    }

    let regularOptions = option.filter((obj) => !!obj.randomise === true);
    const strictOptions = option.filter((obj) => !!obj.randomise === false);

    regularOptions = this.shuffle(regularOptions);

    return [...regularOptions, ...strictOptions];
  };

  renderOption = (choice) => {
    const { step } = this.props;
    const { user } = step;
    const { value, label, color, selected } = choice;

    const optionStyle = {
      backgroundColor: color ? color : this.defaultOptionStyle.bgColor,
      borderColor: color ? color : this.defaultOptionStyle.borderColor,
      color: color ? "#ffffff" : this.defaultOptionStyle.color,
    };

    return (
      <Option key={value} className="rsc-os-option">
        <MultiOptionElement
          className="rsc-os-option-element"
          style={optionStyle}
          user={user}
          onClick={() => this.onOptionClick({ value })}
        >
          <span style={{ marginRight: "4px", verticalAlign: "center" }}>
            {selected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
          </span>
          {label}
        </MultiOptionElement>
      </Option>
    );
  };

  render() {
    const options = this.checkAndRandomiseOption(this.state.optionsCopy);

    // this.setState({optionsCopy: options});
    return (
      <MultiselectStepContainer className="rsc-os">
        <MultiOptions className="rsc-os-options">
          {Object.keys(options)
            .map((key) => options[key])
            .map(this.renderOption)}
        </MultiOptions>
        <MultiSelectButtonContainer>
          <MultiSelectSubmit onClick={() => this.onSubmit()}> Submit </MultiSelectSubmit>
        </MultiSelectButtonContainer>
      </MultiselectStepContainer>
    );
  }
}

MultiselectStep.propTypes = {
  bubbleOptionStyle: PropTypes.objectOf(PropTypes.any).isRequired,
  step: PropTypes.objectOf(PropTypes.any).isRequired,
  triggerNextStep: PropTypes.func.isRequired,
};

export default MultiselectStep;
